import { Translate } from 'next-translate'
import { DateTime, Interval } from 'luxon'
import { Delivery } from '@/network/graphql.g'

export const calculateTimeLeft = (
  startDate: Date,
  endDate: Date
): { days: number; hours: string; minutes: string; seconds: string } => {
  if (!startDate || !endDate) {
    return {
      days: 0,
      hours: '00',
      minutes: '00',
      seconds: '00'
    }
  }

  const interval = Interval.fromDateTimes(
    toLuxonDate(startDate),
    toLuxonDate(endDate)
  )

  if (!interval.isValid) {
    return {
      days: 0,
      hours: '00',
      minutes: '00',
      seconds: '00'
    }
  }

  const duration = interval
    .toDuration(['days', 'hours', 'minutes', 'seconds'])
    .toObject()

  return {
    days: Math.round(duration.days),
    hours: Math.round(duration.hours).toString().padStart(2, '0'),
    minutes: Math.round(duration.minutes).toString().padStart(2, '0'),
    seconds: Math.round(duration.seconds).toString().padStart(2, '0')
  }
}

const STOCK_SUPPLIER_IDS = [6, 14, 15, 70, 89, 121, 150]

const isStockDelivery = (delivery?: Delivery): boolean =>
  STOCK_SUPPLIER_IDS.includes(delivery?.supplierId) ||
  (delivery?.lowest === 1 && delivery?.highest === 1)

export const convertDeliveryToStockLabel = (
  delivery: Delivery,
  t: Translate
): string =>
  isStockDelivery(delivery)
    ? t('Cart.Delivery.inStorage')
    : t('Cart.Delivery.inSupplierStorage')

const toLuxonDate = (date: DateTime | Date): DateTime =>
  date ? (DateTime.isDateTime(date) ? date : DateTime.fromJSDate(date)) : null

export const toShortDate = (date: DateTime | Date, locale: string): string =>
  toLuxonDate(date)?.setLocale(locale).toLocaleString(DateTime.DATE_SHORT)

export const toLongDateShortTime = (
  date: DateTime | Date,
  locale: string
): string => {
  const localizedDate = toLuxonDate(date)?.setLocale(locale)
  return `${localizedDate.toLocaleString(
    DateTime.DATE_FULL
  )}, ${localizedDate.toLocaleString(DateTime.TIME_SIMPLE)}`
}
